export enum ImportProgressEnum {
  HEAD_ROW = "HEAD_ROW",
  MAP_FIELDS = "MAP_FIELDS",
  DATA_CLEANSING = "DATA_CLEANSING",
  DATA_IMPORT = "DATA_IMPORT",
  UPLOAD_IMAGES = "UPLOAD_IMAGES",
}

export enum ImportStatusEnum {
  IN_PROGRESS = "IN_PROGRESS",
  FINISHED = "FINISHED",
  ARCHIVED = "ARCHIVED",
}

export enum CurrentPageEnum {
  UPLOAD_FILE = "UPLOAD_FILE",
  SET_HEADER = "SET_HEADER",
  MAP_FIELDS = "MAP_FIELDS",
  SET_DATA = "SET_DATA",
  IMPORT_DATA = "IMPORT_DATA",
  PENDING = "PENDING",
  UPLOAD_IMAGES = "UPLOAD_IMAGES",
}
